import { render, staticRenderFns } from "./ItemDetailBidLayout.vue?vue&type=template&id=094665ea&scoped=true&"
import script from "./ItemDetailBidLayout.vue?vue&type=script&lang=js&"
export * from "./ItemDetailBidLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094665ea",
  null
  
)

export default component.exports